<h2 mat-dialog-title>
  Message Preview
  <button mat-icon-button style="float: right">
    <mat-icon [mat-dialog-close]="false">close</mat-icon>
  </button>
</h2>
<mat-dialog-content class="mat-typography">
  <div class="form-container" style="text-align: center">
    <h3>This broadcast will be sent to {{data.totalContacts}} contacts</h3>
    <div class="message-item-right">
      <div class="message-item-content">
        <div class="preview-attachment" *ngIf="data.previewFileName">
          <div style="display: inline-block">
            <img [src]="data.previewUrl" alt="preview" *ngIf="data.previewUrl">
            <div>{{data.previewFileName}}</div>
          </div>
        </div>
        <p>{{data.message}}</p>
      </div>
    </div>

  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">Cancel</button>
  <button mat-flat-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>
    <mat-icon>send</mat-icon>
    Send
  </button>
</mat-dialog-actions>
